import { Observable } from 'rxjs/Observable';
import { HttpService } from '../../../globals/providers/http.service';
import { AppEndpoints } from '../../app.endpoints';
import {
	ICreateApplicationRequest,
	IGetRegisteredMobileNumbersRequest,
	IResetCredentialsRequest,
	ISendIbankTermsRequest,
	IAcceptIbankTermsRequest,
} from '../../classes/existing-onboarding-customer/requests';
import {
	ICreateApplicationResponse,
	IGetRegisteredMobileNumbersResponse,
} from '../../classes/existing-onboarding-customer/responses';

export class ExistingOnboardingCustomerService {
	public static sendIbankTerms(request: ISendIbankTermsRequest): Observable<boolean> {
		return HttpService.post<boolean>(AppEndpoints.sendIbankTerms, request);
		// let dummyResponse: boolean = true;

		// return timer(2500).pipe(map(() => dummyResponse));
	}

	public static createApplication(
		request: ICreateApplicationRequest
	): Observable<ICreateApplicationResponse> {
		return HttpService.post<ICreateApplicationResponse>(
			AppEndpoints.createApplication,
			request
		);

		// let dummyResponse: ICreateApplicationResponse = {
		// 	appData: {
		// 		customerCode: request.customerCode,
		// 		debitCardNo: 'string',
		// 		ibankUserId: 'string',
		// 		accountNo: 'string',
		// 		personalDetails: {
		// 			firstName: 'string',
		// 			lastName: 'string',
		// 			fathersName: 'string',
		// 			mothersName: 'string',
		// 			dateOfBirth: '2021-01-19T14:47:54.689Z',
		// 			countryOfBirth: 0,
		// 			birthLocation: 'string',
		// 			gender: 70,
		// 			occupation: 0,
		// 			taxId: 'string',
		// 			username: 'string',
		// 		},
		// 		contactMethods: [
		// 			{
		// 				type: 0,
		// 				value: 'string',
		// 				verification: {
		// 					isVerified: true,
		// 					verificationWay: 0,
		// 				},
		// 			},
		// 		],
		// 		idNo: 'string',
		// 	},
		// 	appInfo: { appId: request.appId, status: 'Sumbitted ' },
		// };

		// return timer(2500).pipe(map(() => dummyResponse));
	}

	/*Review after QA
	public static getApplication( request: IGetApplicationRequest):  Observable<IGetApplicationResponse> {

		return HttpService.post<IGetApplicationResponse>(AppEndpoints.getApplication, request);
	}
	public static saveApplicationData( request: ISaveApplicationDataRequest):  Observable<ISaveApplicationDataResponse> {

		return HttpService.post<ISaveApplicationDataResponse>(AppEndpoints.saveApplicationData, request);
	}*/
	public static getRegisteredMobileNumbers(
		appId: string
	): Observable<IGetRegisteredMobileNumbersResponse> {
		var request: IGetRegisteredMobileNumbersRequest = {
			appId: appId,
		};
		return HttpService.post<IGetRegisteredMobileNumbersResponse>(
			AppEndpoints.getRegisteredMobileNumbers,
			request
		);
		// let dummyResponse: IGetRegisteredMobileNumbersResponse = {
		// 	mobileNo: '6976620549',
		// };

		// return timer(2500).pipe(map(() => dummyResponse));
	}

	public static acceptIbankTerms(request: IAcceptIbankTermsRequest): Observable<boolean> {
		return HttpService.post<boolean>(AppEndpoints.acceptIbankTerms, request);

		// let dummyResponse: boolean = true;

		// return timer(2500).pipe(map(() => dummyResponse));
	}

	public static resetCredentials(request: IResetCredentialsRequest): Observable<boolean> {
		return HttpService.post<boolean>(AppEndpoints.resetCredentials, request);
		// let dummyResponse: boolean = true;

		// return timer(2500).pipe(map(() => dummyResponse));
	}
}
